import type { Nullable } from '@clearverify/types';

import { VerifierTypeOfGovernment } from 'src/api';
import { DroppedFile } from 'src/types/file';

export enum CommercialVerifierCompanyInformationFormFields {
  displayName = 'displayName',
  logoFile = 'logoFile',
  legalBusinessName = 'legalBusinessName',
  commercialName = 'commercialName',
  fEIN = 'fEIN',
  industry = 'industry',
  contactEmail = 'contactEmail',
  contactPhone = 'contactPhone',
  websiteURL = 'websiteURL',
  address = 'address',
}

export enum GovernmentVerifierCompanyInformationFormFields {
  displayName = 'displayName',
  logoFile = 'logoFile',
  governmentEntityName = 'governmentEntityName',
  department = 'department',
  typeOfGovernment = 'typeOfGovernment',
  fEIN = 'fEIN',
  commercialName = 'commercialName',
  industry = 'industry',
  contactEmail = 'contactEmail',
  contactPhone = 'contactPhone',
  websiteURL = 'websiteURL',
  address = 'address',
}

export enum CompanyInformationFormAddressFields {
  address = 'address',
  street = 'street',
  city = 'city',
  state = 'state',
  zipCode = 'zipCode',
  county = 'county',
}

type CompanyInformationFormAddressValues = {
  [CompanyInformationFormAddressFields.street]?: Nullable<string>;
  [CompanyInformationFormAddressFields.city]?: Nullable<string>;
  [CompanyInformationFormAddressFields.state]?: Nullable<string>;
  [CompanyInformationFormAddressFields.zipCode]?: Nullable<string>;
  [CompanyInformationFormAddressFields.county]?: Nullable<string>;
};

export type CommercialVerifierCompanyInformationFormValues = {
  [CommercialVerifierCompanyInformationFormFields.displayName]: Nullable<string>;
  [CommercialVerifierCompanyInformationFormFields.logoFile]: Nullable<DroppedFile>;
  [CommercialVerifierCompanyInformationFormFields.legalBusinessName]: Nullable<string>;
  [CommercialVerifierCompanyInformationFormFields.commercialName]?: Nullable<string>;
  [CommercialVerifierCompanyInformationFormFields.fEIN]: Nullable<string>;
  [CommercialVerifierCompanyInformationFormFields.industry]:
    | Nullable<string>
    | Nullable<{ value: Nullable<string>; label: Nullable<string> }>;
  [CommercialVerifierCompanyInformationFormFields.contactEmail]: Nullable<string>;
  [CommercialVerifierCompanyInformationFormFields.contactPhone]: Nullable<string>;
  [CommercialVerifierCompanyInformationFormFields.websiteURL]?: Nullable<string>;
  [CommercialVerifierCompanyInformationFormFields.address]: Nullable<CompanyInformationFormAddressValues>;
};

export type GovernmentVerifierCompanyInformationFormValues = {
  [GovernmentVerifierCompanyInformationFormFields.displayName]: Nullable<string>;
  [GovernmentVerifierCompanyInformationFormFields.logoFile]: Nullable<DroppedFile>;
  [GovernmentVerifierCompanyInformationFormFields.governmentEntityName]: Nullable<string>;
  [GovernmentVerifierCompanyInformationFormFields.department]: Nullable<string>;
  [GovernmentVerifierCompanyInformationFormFields.commercialName]?: Nullable<string>;
  [GovernmentVerifierCompanyInformationFormFields.fEIN]: Nullable<string>;
  [GovernmentVerifierCompanyInformationFormFields.typeOfGovernment]: Nullable<VerifierTypeOfGovernment>;
  [GovernmentVerifierCompanyInformationFormFields.industry]:
    | Nullable<string>
    | Nullable<{ value: Nullable<string>; label: Nullable<string> }>;
  [GovernmentVerifierCompanyInformationFormFields.contactEmail]: Nullable<string>;
  [GovernmentVerifierCompanyInformationFormFields.contactPhone]: Nullable<string>;
  [GovernmentVerifierCompanyInformationFormFields.websiteURL]?: Nullable<string>;
  [GovernmentVerifierCompanyInformationFormFields.address]: Nullable<CompanyInformationFormAddressValues>;
};
